export default {
  version: '1.2.0',
}
